import script from "./adminVideoButton.vue?vue&type=script&setup=true&lang=js"
export * from "./adminVideoButton.vue?vue&type=script&setup=true&lang=js"

import "./adminVideoButton.vue?vue&type=style&index=0&id=53d37a33&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53d37a33"]])

export default __exports__